import { Component, OnInit } from '@angular/core';
import { WindowRef } from 'Src/ng2/shared/services/windowRef';

@Component({
  selector: 'other-tools-resources',
  template: require('./other-tools-resources.component.html'),
  styles: [require('./other-tools-resources.component.scss')],
})
export class OtherToolsResourcesComponent implements OnInit {
  sdcLink: string = 'https://sdc.newvisions.org';
  dataPortalResLink: string = 'https://sites.google.com/newvisions.org/data-portal-resources/';
  cloudLabLink: string = 'https://cloudlab.newvisions.org/';
  curriculumLink: string = 'https://curriculum.newvisions.org/';

  constructor(private windowRef: WindowRef) {}

  ngOnInit() {
    //
  }

  goExternal($url: string): void {
    const window = this.windowRef.nativeWindow;
    window.open($url, '_blank');
  }
}
